import React from 'react'

function MegaphoneBig() {
  return (
    <svg
      width={96}
      height={85}
      viewBox="0 0 96 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.32}>
        <path
          d="M4 35.368s0-12.631 20.21-15.157C37.063 18.604 56.528 7.946 67.159 2.526 72.112 0 76 0 76 0S62.105 5.052 62.105 40.42C62.105 75.79 76 80 76 80s-5.538 0-8.842-1.685c-10.63-5.42-30.095-16.077-42.948-17.683C4 58.105 4 45.474 4 45.474V35.369z"
          fill="#fff"
        />
        <path
          d="M89.474 40c0 10.807-1.757 20.474-4.506 27.346-1.377 3.443-2.954 6.06-4.576 7.775-1.616 1.71-3.102 2.353-4.392 2.353-1.29 0-2.776-.644-4.392-2.353-1.622-1.715-3.199-4.332-4.576-7.775-2.75-6.872-4.506-16.54-4.506-27.346 0-10.807 1.757-20.474 4.506-27.346 1.377-3.443 2.954-6.06 4.576-7.775C73.224 3.17 74.709 2.526 76 2.526c1.29 0 2.776.644 4.392 2.353 1.622 1.715 3.199 4.332 4.576 7.775 2.749 6.872 4.506 16.54 4.506 27.346z"
          stroke="#fff"
          strokeWidth={5.053}
        />
        <path
          d="M58.526 40c0 4.02 1.024 7.54 2.545 9.975 1.544 2.47 3.353 3.499 4.929 3.499s3.385-1.03 4.929-3.5c1.521-2.433 2.545-5.953 2.545-9.974 0-4.02-1.024-7.54-2.545-9.975-1.544-2.47-3.353-3.499-4.93-3.499-1.575 0-3.384 1.03-4.928 3.5-1.521 2.433-2.545 5.954-2.545 9.974z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={5.053}
        />
        <path d="M30 58h8v32a4 4 0 01-8 0V58z" stroke="#fff" strokeWidth={4} />
        <path fill="#fff" d="M32 80h4v4h-4z" />
      </g>
    </svg>
  )
}

export default React.memo(MegaphoneBig)
